// extracted by mini-css-extract-plugin
export var form = "serachByWheel-module--form--ygGbI";
export var formControls = "serachByWheel-module--formControls--VtmR8";
export var itemsDisplay = "serachByWheel-module--itemsDisplay--W0fRE";
export var filterHeader = "serachByWheel-module--filterHeader--ILn+Y";
export var filters = "serachByWheel-module--filters--w2Z1-";